import React from 'react';
import { ListItem, ListItemContent, Box } from "@mui/joy";
import { Button } from '../Button';
import { useTranslation } from 'react-i18next';
import { Icon } from 'src/mtska-frontend-app-component/assets';
import { useFormatter } from 'src/mtska-frontend-app-component/utils';

const RelationshipDelivery = ({ k, v, editing, detailInspector = true, handleItemDetail, handleItemRemove, loadingDissociation, view }) => {
	const { t } = useTranslation();
	const { formatDate } = useFormatter();

	return (
		<ListItem k={k} variant="outlined" className="relationship-element">
			<ListItemContent className="relationship-element-content">
				<Box className="icon-file icon-type">
					{v.commodity === 'electricity' && <Icon icon="faLightbulb" className="fileicon" style={{ color: "var(--customer-300)" }} />}
					{v.commodity === 'gas' && <Icon icon="faFireFlameSimple" className="fileicon" />}
				</Box>

				<Box className="type coupled top-row">
					<Box className="label">{t('commodity')}</Box>
					<Box className="value">{t(v?.commodity) ?? '-'}</Box>
				</Box>

				<Box className="type coupled top-row">
					<Box className="label">{v?.marketType ?? '-'}</Box>
					<Box className="value">{v?.offerDescription ?? '-'}</Box>
				</Box>

				<Box className="coupled top-row">
					<Box className="label"><Icon icon="faHouse" />{t(v?.pdr) ?? ''}</Box>
					<Box className="value">{v?.city ?? '-'} ({v?.region ?? '-'})</Box>
				</Box>

				<Box className="type coupled top-row">
					<Box className="label">{v?.status ?? '-'}</Box>
					<Box className="value">
						<Icon icon="faCalendarHeart" />{formatDate(v?.start_at) ?? ''} <Icon icon="faCalendarXmark" />{formatDate(v?.end_at) ?? ''}
					</Box>
				</Box>
			</ListItemContent>

			{editing && handleItemDetail && detailInspector && <Button onClick={() => handleItemDetail(v)} icon="faPen" variant="plain" />}
			{editing && handleItemRemove && <Button onClick={() => handleItemRemove(v)} icon="faClose" variant="plain" loading={loadingDissociation} />}
		</ListItem>
	);
};

export default RelationshipDelivery;
